import React from 'react';
import { IconProps } from '../types';

export const PrintDesignIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8892_8420)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5 27.3333V-0.333374H3V27.3333C3 29.7522 4.91438 31.6666 7.33333 31.6666H27.3334C29.7523 31.6666 31.6667 29.7522 31.6667 27.3333V25.6666H29V-0.333374H27V25.6666H9.66673V27.3333C9.66673 28.3272 9.13928 28.8759 8.51146 29.2275C8.18807 29.4086 7.85488 29.5232 7.59657 29.5921C7.46939 29.626 7.36543 29.6475 7.29675 29.66L7.26468 29.6657C5.98364 29.6309 5 28.6247 5 27.3333ZM10.9641 29.6666H27.3334C28.5343 29.6666 29.4886 28.816 29.6444 27.6666H11.6552C11.5979 28.4827 11.3317 29.1411 10.9641 29.6666Z"
                fill={color}
            />
            <path d="M8 8.66663H13.3333V10.6666H8V8.66663Z" fill={color} />
            <path d="M24 8.66663H14.6667V10.6666H24V8.66663Z" fill={color} />
            <path d="M16 4.66663H21.3333V6.66663H16V4.66663Z" fill={color} />
            <path d="M20 0.666627L8 0.666626V2.66663L20 2.66663V0.666627Z" fill={color} />
            <path d="M8 16.6666L20 16.6666V18.6666L8 18.6666V16.6666Z" fill={color} />
            <path d="M14.6667 4.66663L8 4.66663V6.66663L14.6667 6.66663V4.66663Z" fill={color} />
            <path d="M8 20.6666H14.6667V22.6666H8V20.6666Z" fill={color} />
            <path d="M25.3333 20.6666L16 20.6666V22.6666H25.3333V20.6666Z" fill={color} />
            <path d="M8 12.6666H22.6667V14.6666H8V12.6666Z" fill={color} />
        </g>
        <defs>
            <clipPath id="clip0_8892_8420">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
